import { fetcher } from "helpers/fetcher";

import { TAddStaffInsuranceReq, TAddStaffInsuranceRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const addEmployeeInsurance = async (payload: TAddStaffInsuranceReq) => {
  return await fetcher<TAddStaffInsuranceRes, TAddStaffInsuranceReq["data"]>(
    ENDPOINT.USER.ADD_EMPLOYEE_INSURANCE,
    {
      data: payload.data,
      headers: {
        [API_HEADER.USER_ID]: payload.idUser,
        [API_HEADER.VERSION]: ENDPOINT.USER.ADD_EMPLOYEE_INSURANCE.version,
      },
    }
  );
};

export const mutationAddEmployeeInsurance = async (
  payload: TAddStaffInsuranceReq
) => {
  return (await addEmployeeInsurance(payload)).data.message;
};

mutationAddEmployeeInsurance._key = (payload: TAddStaffInsuranceReq) => [
  ENDPOINT.USER.ADD_EMPLOYEE_INSURANCE.url,
  payload,
];
